import { render, staticRenderFns } from "./CombiList.vue?vue&type=template&id=55b2dd10"
import script from "./CombiList.vue?vue&type=script&lang=js"
export * from "./CombiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports